import { useIntl } from 'Features/Intl/context';
import { createButtonVariants } from 'Features/SRP/Components/Button';
import { cn } from 'Features/Shared/Utils/classNames';
import Link from 'next/link';
import { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {}

export function EstimatorCTA({ className, ...rest }: Props) {
  const { __ } = useIntl();

  return (
    <div
      className={cn(
        'not-prose bg-slate-50 border border-slate-100 p-8 rounded-3xl lg:p-16',
        className,
      )}
      {...rest}
    >
      <div className="text-left">
        <h2 className="text-4xl font-bold font-space tracking-tight text-slate-900 lg:text-6xl">
          {__('estimator.title')}
        </h2>
        <p className="mt-6 text-lg leading-8 text-slate-600">{__('estimator.subtitle')}</p>
        <div className="mt-10">
          <Link href="/estimator">
            <a className={createButtonVariants({ variant: 'blue', size: 'lg' })}>
              {__('estimator.action')}
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}
